import { render, staticRenderFns } from "./v-truncate.vue?vue&type=template&id=066e2aa3&scoped=true&"
import script from "./v-truncate.vue?vue&type=script&lang=js&"
export * from "./v-truncate.vue?vue&type=script&lang=js&"
import style0 from "./v-truncate.vue?vue&type=style&index=0&id=066e2aa3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066e2aa3",
  null
  
)

export default component.exports